<!-- <link rel="stylesheet" [href]='safeUrl'>
<link rel="stylesheet" [href]="safeUrl2"/> -->
<div class="bg-body">
  <app-header-private (lang)="onLangChange($event)" (changeBranch)="onChangeBranchRequest($event)"></app-header-private>
  <div class="dashboard-body">
    <div class="col-md-12  dashboard-sec">
      <app-branch-selection (branchObj)="onBranchSelect($event)"
                            (branchSelectionAction)="onBranchSelectionAction($event)"
                            *ngIf="true" [@openClose]="isBranchOpened ? 'open' : 'closed'">

      </app-branch-selection>
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-sidemenu [disableSideMenu]="disableSideMenu" *ngIf="disableSideMenu"></app-sidemenu>
</div>
